import { render } from "./HeroiconsOutlineShieldCheck.vue?vue&type=template&id=516360b9"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShieldCheck.vue"]])

export default __exports__